import styled from 'styled-components';
import { colors } from '@/styles';

export const ListCell = styled.div`
  display: flex;
  height: 100%;
  padding: 4px;
  & > * {
    display: flex;
  }

  .count {
    margin-left: 10px;
    font-style: italic;
    color: ${colors.secondary.mediumGray};
    white-space: nowrap;
  }
  /* justify-content: center; */
`;

export const ListDetails = styled.div``;
